import { axiosGet, axiosPost, axiosPut } from '../plugins/axios.plugins';

const API_ENDPOINTS = {
  APP_DATA_BASEURL: `${process.env.VUE_APP_DATA_API}`,
};

export const updateSchemaField = (query, payload) => {
  return axiosPut(
    `${API_ENDPOINTS.APP_DATA_BASEURL}/user-tables/${query.tableName}/table-schema/${query.fieldName}`,
    payload
  );
};
export const createDatabaseTable = (payload) => {
  return axiosPost(`${API_ENDPOINTS.APP_DATA_BASEURL}/user-tables`, payload);
};
export const getTableColumns = (payload) => {
  return axiosPost(
    `${API_ENDPOINTS.APP_DATA_BASEURL}/list-table-columns`,
    payload
  );
};
export const getCustomDatabaseItems = (tableName, params = '') => {
  return axiosGet(
    `${API_ENDPOINTS.APP_DATA_BASEURL}/user-tables/${tableName}/items${params}`
  );
};
export const getCustomDatabaseItem = (tableName, itemID) => {
  return axiosGet(
    `${API_ENDPOINTS.APP_DATA_BASEURL}/user-tables/${tableName}/items/${itemID}`
  );
};
